import { StyledMarkdown } from './markdown-text.style';

export type Props = { text: string; testId?: string };

export const MarkdownText = ({ text, testId }: Props): JSX.Element => {
  return <StyledMarkdown data-testid={testId}>{text}</StyledMarkdown>;
};
